

const Assets = {
    Images : {
        logo_mpm_big : require('./images/logo-mpm-big.png'),
        icon_menu_dashboard: require('./images/dashboard_icon.png'),
        icon_menu_cession_capture: require('./images/cessionCapture_icon.png'),
        icon_menu_cesion_produits: require('./images/sessionProduits_icon.png'),
        icon_menu_demande_export: require('./images/demandeExport_icon.png'),
        cession_capture_header_icon : require('./images/cession_capture_header_icon.png'),
        cession_produit_header_icon: require('./images/cession_produit_header_icon.png'),
        demande_export_header_icon: require('./images/demande_export_header_icon.png'),
        doc_icon: require('./images/doc_icon.png'),
        unautorized: require('./images/unauthorized.png')
    }
};
export default Assets;